import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTER_SELECTED,
  SET_DATES,
  SET_LOADING,
  UPDATE_DATES,
  FETCH_TABLE_DATA_SUCCESS,
  UPDATE_VIEW_FILTER,
  FETCH_FILTERS_SUCCESS,
  SET_SELECTED_METRICS
} from "./BrandLeaderBoardSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersDirty: false,
  selectedRequestDates: {},
  cardsData: {},
  viewOptions: [
    {
      id: 1,
      name: "Summary"
    },
    {
      id: 2,
      name: "Details"
    }
  ],
  metrics: [],
  totals: {
    top_ranking: []
  },
  selectedMetrics: [],
  selectedViewOption: {
    id: 1,
    name: "Summary"
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedViewOption: initialState.selectedViewOption
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      filtersDirty: false,
      cardsData: action.payload?.table,
      totals: action.payload?.totals
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      metrics: action.payload?.metrics,
      selectedMetrics: action.payload?.metrics.filter((elem) => elem.checked)
    }),
    [SET_SELECTED_METRICS]: (state, action) => ({
      ...state,
      selectedMetrics: action.payload,
      filtersDirty: true
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload
    }),
    [UPDATE_VIEW_FILTER]: (state, action) => ({
      ...state,
      selectedViewOption: action.payload || state.selectedViewOption,
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      filtersDirty: true
    })
  },
  initialState
);
